export const CONFIG = {
    client_name : "twl",
    client_display_name : "TWL",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/twl/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "67059",
    foerderung : true,
    development_mode: false,
}
